/** Бэкенд хранит микро-USDT (1 USDT = 1e6) */
export function formatMicroUsdt(micro: number | string | null | undefined): string {
  const n = Number(micro);
  if (Number.isNaN(n)) return '0';
  const v = n / 1_000_000;
  return v.toFixed(6).replace(/\.?0+$/, '') || '0';
}

export function parseUsdtInputToMicro(raw: string): number | null {
  const s = String(raw ?? '')
    .trim()
    .replace(',', '.');
  if (!s) return null;
  const n = Number(s);
  if (Number.isNaN(n) || n < 0) return null;
  return Math.round(n * 1_000_000);
}
